import { ChangeDetectionStrategy, Component, computed, input, Input } from '@angular/core';

@Component({
  selector: 'lbt-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  readonly color = input<'success' | 'white' | 'primary' | 'warn' | 'orange'>('primary');
  readonly size = input<'large' | 'middle' | 'small'>('middle');
  readonly type = input<'text' | 'icon' | 'textWithIcon' | 'roundWithIcon'>('text');
  readonly disabled = input<boolean>(false);

  readonly classList = computed<string>(
    () => `lbt-button lbt-button-${this.color()} lbt-button-size-${this.size()} lbt-button-${this.type()}`
  );
}
